<!-- Modal -->
<app-deprecated-modal-form
    #modalForm
    [form]="departmentForm"
    (save)="onSave()"
    (cancel)="onCancel()"
    headerText="{{ 'employees.department.editDepartment' | translate }}"
>
    <app-department-form #departmentForm [department]="department"></app-department-form>
</app-deprecated-modal-form>

<app-deprecated-confirmation-dialog
    #confirmDeleteDialog
    [negative]="true"
    [disableAction]="department?.employeeCount > 0"
    [description]="
        department?.employeeCount
            ? 'employees.department.cannotDeleteDepartmentWithEmployees'
            : ('employees.department.sureWantToDelete' | translate)
    "
    [label]="'delete' | translate"
></app-deprecated-confirmation-dialog>

<!-- Body -->
<div class="ui basic segment" [class.loading]="isLoading">
    <app-header title="{{ 'employees.department.department' | translate }}" [back]="true" [contextMenu]="true">
        <app-context-item
            *permission="editPermission; all: true"
            label="{{ 'employees.department.edit' | translate }}"
            (click)="modalForm.show()"
        >
        </app-context-item>
        <app-context-item
            *permission="editPermission; all: true"
            label="{{ 'employees.department.delete' | translate }}"
            (click)="onDelete()"
        ></app-context-item>
    </app-header>

    <div class="ui segment">
        <div class="header">
            <div class="ui donut" [style.borderColor]="department.color"></div>

            <app-segment-header [title]="department?.name" [editPermission]="editPermission"></app-segment-header>
        </div>

        <div
            class="content-wrapper"
            [innerHTML]="
                department?.description
                    ? (department.description | sanitizeHtml)
                    : ('employees.department.noDescription' | translate)
            "
        ></div>
    </div>

    <!-- Employees -->
    <div class="ui table segment" *permission="viewPeoplePermission">
        <app-segment-header
            title="{{ 'employees.department.employees' | translate }}"
            [paginator]="paginator"
        ></app-segment-header>

        <!-- Content -->
        <table *ngIf="paginator.total; else empty" class="ui selectable table">
            <thead>
                <tr>
                    <th>{{ 'employees.department.fullName' | translate }}</th>
                    <th>{{ 'employees.department.position' | translate }}</th>
                    <th>{{ 'employees.department.status' | translate }}</th>
                    <th>{{ 'employees.department.department' | translate }}</th>
                    <th>{{ 'employees.department.hireDate' | translate }}</th>
                </tr>
            </thead>
            <tbody>
                <ng-container *ngFor="let employee of paginator.values">
                    <tr [routerLink]="['/employees', 'directory', employee.id]">
                        <td>
                            <app-avatar [employee]="employee" [name]="true"></app-avatar>
                        </td>
                        <td>{{ employee.job?.title }}</td>
                        <td class="capitalize">{{ employee.status }}</td>
                        <td>{{ employee.department?.name }}</td>
                        <td>{{ employee?.hiredAt | appDate: 'mediumDate' }}</td>
                    </tr>
                </ng-container>
            </tbody>
        </table>

        <ng-template #empty>
            <app-empty-state
                src="/assets/illustrations/magnifying-glass.png"
                label="{{ 'employees.department.noEmployeesBelongToThisDepartment' | translate }}"
            ></app-empty-state>
        </ng-template>
    </div>
</div>
